import { render, staticRenderFns } from "./MitVolumesExplore.vue?vue&type=template&id=680775fc&scoped=true"
import script from "./MitVolumesExplore.vue?vue&type=script&lang=js"
export * from "./MitVolumesExplore.vue?vue&type=script&lang=js"
import style0 from "./MitVolumesExplore.vue?vue&type=style&index=0&id=680775fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680775fc",
  null
  
)

export default component.exports